export const taskCenter = {
  syrw: "Começa com a missão e termina com você",
  zjlbt: "O bônus Biking USDT não vai parar",
  wdjj: "Meu bônus",
  rwsm: "Descrição da tarefa",
  rwlb: 'Lista de tarefas',
  jljl: "Registro de recompensa",
  klq: "Disponível para coleção:",
  flzm: "Portão de bem-estar Biking",
  dcjl: "Receba recompensas em USDT assim que conseguir e acompanhe você durante todo o caminho",
  yjlq: "Coleta com um clique",
  lqcg: "Recebido com sucesso",
  wdl: "Não logado",
  jxz: "Em andamento",
  ylq: "Recebido",
  rwjd: 'Progreso de la tarea',
  xsrw: 'Tarea de principiante',
  hyrw: 'Tarea de contrato',
  cjrz: 'Certificación Junior',
  gjrz: 'Autenticación avanzada',
  scbbjy: 'Primera transacción de monedas',
  schyjy: 'Primera transacción de contrato',
  sccz: 'Primera recarga',
  schyhz: 'Primer contrato de transferencia',
  jyl: 'Volumen de operaciones',
  ylje: 'Cantidad de beneficio',
  ksje: 'monto de la pérdida',
  dbkcbzj: 'Margen de apertura único',
  rjl: 'Monto del depósito',
  dbczje: 'Cantidad de recarga única',
  rwxq: 'Detalles de la tarea'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/task/pt_BR.js